import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { DataService } from '../../../data.service';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SessionStorageService } from 'angular-web-storage';

@Injectable({
  providedIn: 'root',
})
export class DashcontentserviceService implements Resolve<any> {

  constructor(
    public session: SessionStorageService,
    private server: DataService,
    private httpClient: HttpClient
  ) {}

  resolve(): Observable<any> {
    const cookieValue = this.session.get('sessionID');
    const path = this.server.Getpath();

    const load = { val: cookieValue, key: 'load' };
    const me   = { Id: cookieValue, key: 'user' };
    const mte  = { val: cookieValue, key: 'depN' };
    const upi  = { Id: cookieValue, key: 'upi' };

    return forkJoin({
      types: this.httpClient.post(path, load),
      dep:   this.httpClient.post(path, me),
      his:   this.httpClient.post(path, mte),
      upi:   this.httpClient.post(path, upi)
    }).pipe(
      map(result => result),
      catchError(error => {
        console.error('Resolver failed:', error);
        return of(null); // prevents crash
      })
    );
  }
}
